module.exports = __webpack_public_path__ + "8687fa15b7b810e9740775b53ba3a6b1.png";


//////////////////
// WEBPACK FOOTER
// ../assets/neuron-screen.png
// module id = 518
// module chunks = 0